import { KnowledgeAPIModel, PaginatedAPI } from 'src/app/models/api.model'

export interface KnowledgeState {
  details: KnowledgeAPIModel
  search: PaginatedAPI<KnowledgeAPIModel>
  quickViewList: PaginatedAPI<KnowledgeAPIModel>
}

export const initialKnowledgeState: KnowledgeState = {
  details: undefined,
  search: undefined,
  quickViewList: undefined
}
